"use client";

/**
 * "Save as PDF" is a print dialog wearing the name people actually search for.
 * The document's print stylesheet turns the page white, drops the chrome and
 * lets the diagrams through, so what comes out is a document rather than a
 * screenshot of a website.
 */

export default function PrintButton({ className }: { className?: string }) {
  return (
    <button type="button" onClick={() => window.print()} className={className}>
      Save as PDF
    </button>
  );
}
